export const defaultState = {
  type: 'None',
  size: null,
  industries: null,
  country: null,
  name: '',
  address: {
    line1: '',
    line2: '',
    postCode: '',
    city: '',
    country: null,
  },
  invoiceAddressSame: true,
  invoiceAddress: {
    line1: '',
    line2: '',
    postCode: '',
    city: '',
    country: null,
  },
  status: true,
  contactPerson: '',
  contactEmail: '',
  agreementSignedDate: null,
  kamUser: null,
  certificationBody: '',
  tempCertificationBody: '',
  certificationBodyLevelDomains: {},
};

const UPDATE_FIELD = 'UPDATE_FIELD';

export const updateFieldCreator = (payload) => ({ type: UPDATE_FIELD, payload });

export default function (state = defaultState, action) {
  if (action.type === UPDATE_FIELD) {
    if (action.payload.name === 'certificationBodyLevelDomains') {
      return { ...state, tempCertificationBody: '', [action.payload.name]: action.payload.value };
    }
    return { ...state, [action.payload.name]: action.payload.value };
  }

  return state;
}
